import { useState, useEffect, useRef } from 'react';
import { BottomTooltip } from 'ui/tooltip';
import { CAMPAIGN_TEMPLATE_OPTION_TEST_ID } from './constants';
import { StyledTruncate } from './styles';

export type CampaignTemplateOptionProps = {
  text: string;
};

export const CampaignTemplateOption = ({ text }: CampaignTemplateOptionProps) => {
  const ref = useRef<HTMLButtonElement>(null);
  const maxWidth = 160;
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (ref?.current?.scrollWidth && ref?.current?.scrollWidth > maxWidth) {
      setIsTruncated(true);
    } else if (ref?.current?.scrollWidth && ref?.current?.scrollWidth <= maxWidth) {
      setIsTruncated(false);
    }
  });

  return (
    <>
      <BottomTooltip isEnabled={isTruncated} tooltipContent={text}>
        <StyledTruncate data-test={CAMPAIGN_TEMPLATE_OPTION_TEST_ID} ref={ref} maxWidth={maxWidth}>
          {text}
        </StyledTruncate>
      </BottomTooltip>
    </>
  );
};
